export const exotics = [
  911,
  "Cayenne",
  "M3",

  "Panamera",
  "LR4",
  "Boxster",
  "Cayman",
  "Model S",
  "Continental",
  "R8",
  "M5",
  "GranTurismo",
  "Viper",
  "G-Class",
  "Quattroporte",
  "M4",
  "Macan",
  "Granturismo",
  "Model X",
  "Ghibli",
  "Discovery",
  "M6",
  "DB9",
  "V8 Vantage",
  "Boxster S",
  "Gallardo",
  "Continental GT",
  "Hurracan",
  "California",
  "A8",
  "Ghost",
  
  718,
  "Continental GTC",
  "LX 570",
  "Continental Flying Spur",
  "911 Turbo",
  "GT-R",
  "S7",
  "Model 3",
  "RS7",
  "M3 Coupe",
  "S550",
  "Huracan",
  "Evora",
  "Cayman S",
  "G80",
  "M2",
  "Aventador",
  "Carrera",
  "Flying Spur",
  "S8",
  "458 Italia",
  "Elise",
  "F430",
  "Giulia (952)",
  "i8",
  "Cayenne S",
  "URUS",
  "I8",
  "Wraith",
  "LR2",
  "AMG GT",
  "Levante",
  "Rapide",
  "G550",
  "Model Y",
  "S",
  "Bentayga",
  "RS5",
  "GTR",
  "Arnage",
  "MP4-12C",
  "720S",
  "488 Spider",
  "Cayenne Turbo",
  "Stelvio",
  "Ghost",
  "570S",
  "A8 L",
  "Phantom",
  "911 GT3",
  "California T",
  "458 Spider",
  "Mulsanne",
  "FF",
  "911 Turbo S",
  "NSX",
  "4C",
  "DB11",
  "A8L",
  "Azure",
  "M4 Coupe",
  "650S",
  "Murcielago",
  "S550",
  "Cayenne GTS",
  458,
  "Carrera S",
  "911 Carrera",
  "Vantage",
  "GT3",
  "Panamera Hybrid",
  "Gran Turismo",
  "360 Spider",
  "AMG",
  "Range Rover HSE",
  "Spyder",
  "Dawn",
  "Defender",
  "LC",
  "Boxter",
  "Giulia",
  "Vanquish",
  "G70",
  "SLS AMG",
  "M3 CONVERTIBLE",
  "DBS",
  "Sport",
  "Alpina B7",
  911,
  "Cayenne Hybrid",
  "Discovery Sport",
  "M8",
  "S 550",
  "911 Carrera S",
  "GTC",
  "G Class AMG",
  "HSE",
  "Macan GTS",
  "911 S",
  "Taycan",
  "Macan Turbo",
  "360 Spider/360 Spider F1",
  "911 4S",
  911,
  "Carrera 911",
  "Coupe",
  "488 GTB",
  "G500",
  "G90",
  "Panamera Turbo",
  "SL550",
  "Boxter S",
  "Cullinan",
  "S550",
  "RS 7",
  "G Wagon",
  "911 C4S",
  "Macan S",
  "Cayenne Diesel",
  "Evoque",
  "600LT",
  "F430 Spider",
  "X",
  "E350",
  "Phantom",
  488,
  "Cayman GTS",
  500,
  "Challenger SRT Demon",
  "G63",
  "C300",
  "SL500",
  "Virage",
  "570GT",
  "488 Pista",
  "Karma",
  "Urus",
  "911S",
  "Grand Turismo",
  "Hurricane",
  "SL550",
  "M4",
  "GranTurismo S",
  "GT3RS",
  "F12 Berlinetta",
  911,
  "Evoque",
  "Cayenne Turbo S",
  "Range Rover Sport HSE",
  "macan",
  "V8",
  "Cambiocorsa",
  "GranTurismo Convertible",
  "Turbo S",
  "V12 Vantage",
  "C7",
  "Sprinter",
  "F430 Coupe",
  "GT 500",
  "Carrera 4S",
  "Range Rover Supercharged",
  "GT",
  "F12",
  "G63",
  "Wraith",
  "SL500",
  "Quattroporte GTS",
  "911 Turbo Cabriolet",
  "911 GT3RS",
  "GT",
  3,
  "812 Superfast",
  "911 GT3 RS",
  "CLS 550",
  "360 Modena/360 Modena F1",
  "SL 550",
  "911 Carrera 4",
  "Ghibli SQ4",
  "Quattroporte S",
  "Ghibli S Q4",
  "360 Modena",
  "Continental Gt",
  "Range Rover Autobiography",
  "R 8",
  "911 Carrera 4S",
  "Exige",
  "Discovery 2",
  "XK",
  "911 Targa 4S",
  "GT",
  "Range Rover SE",
  "M3 Convertible",
  "GranSport Spyder",
  "Gallardo Spyder",
  "Gtr",
  "GLS 63 AMG",
  "G Class",
  "C-Class",
  "CLS500",
  "GranTurismo",
  "GT4",
  "GranTurismo Sport",
  "911 Gt3",
  "S 550",
  "Panamera 4",
  "Convertible",
  "Silver Seraph",
  "E550",
  "911 turbo s",
  "Cayman R",
  "911 4s",
  "Targa 4S",
  "C300",
  "Panamera 4S",
  996,
  "Range Rover Sport SVR",
  "Boxster Spider",
  "GranSport",
  "Corvette ZR1",
  "GL550",
  "911 GTS",
  "HSE",
  "LR4 HSE LUX",
  "GranTurismo",
  "Rapide S",
  "718 Cayman",
  "911 Turbo Convertible",
  "Cayman",
  599,
  "M3",
  "LC 500",
  "XKR",
  "B7",
  "Turbo",
  "911 turbo",
  "Demon",
  "E400",
  "570s",
  "Quadrifoglio",
  "458 Speciale",
  "Esprit V8",
  "911 Targa",
  "V12 Vanquish",
  "R8 Spyder",
  "Ferrari",
  "S600",
  "Continental Supersports",
  "DB7 Vantage",
  "Velar",
  "Huracan EVO",
  "Boxster GTS",
  "718 Boxster",

  "Cayman GT4",
  "Range Rover Sport HSE LUX",
  "SL400",
  "Cabriolet",
  "DB7",
  "Vantiage",
  "4C Spider",
  "boxster",
  "E63 AMG",
  "Silver Spur",
  "E300",
  "Cayene",
  "DB9 volante",
  "F8",
  "cayenne",
  "GranTurismo MC",
  "Panamera Turbo S",
  "X5M",
  "Vanquish Volante",
  "Cayenne s",
  "R272",
  "SL600",
  "911 Convertible",
  "F-Type",
  "CLS 63 AMG",
  "Gt3",
  "LR4 HSE",
  "Carrera Cabriolet",
  "G63 AMG",
  "M",
  "cayman",
  "S560",
  "488 spider",
  "Model X P90D",
  "macan turbo",
  "Esprit",
  "C63 AMG",
  "Ranger Rover",
  "Panamera Turbo Executive",
  "Discovery Sport HSE",
  "Autobiography",
  "AMG GTR",
  
  "Model S P90D",
  "XK8",
  "GLE 350",
  "Db9",
  "Coupe Cambiocorsa",
  "SL500",
  "GL550",
  "SL63 AMG",
  "Ghibili",
  "model x",
  "Panamera Gts",
  "LR2",
  "Macan turbo",
  "Hse",
  "4.6 HSE",
  "E350",
  "996 Turbo",
  "Alpina",
  "mulsanne",
  "GLK350",
  "SQ4",
  "S500",
  "Challenger SRT",
  "Julia",
  "Lr2",
  "C250 Sport",
  "Coupe GT",
  "lr4",
  "GTB",
  "Continental Convertible",
  "Dawn",
  "Targa 4 GTS",
  911,
  "Continental GT V8",
  "S63 AMG Coupe",
  "G-Class 63",
  "A22",
  "Continental GT speed",
  "Amg",
  "G-500",
  "GTC4Lusso",
  "GTC AMG",
  "Boxster s",
  "911 Gt3 Rs",
  "Huracan Performante",
  "Lr4",
  "G63 AMG",
  "ghost",
  "Cullinan Black Badge",
  "Continental GT Speed",
  "911 Carrera S Cabriolet",
  "Carrera S Cabriolet",
  "Panamera",
  "Range Rover 4.6 HSE",
  "SENNA",
  "Panamara",
  "G-Class",
  "Murcielago Roadster",
  "Carrera GT",
  "911 Series",
  "F430 Scuderia",
  "Discovery SE",
  "Continental GT Coupe",
  "GLC",
  "Lavante",
  "i8",
  "Aventador SV",
  "Portofino",
  "911 Carrera Cabriolet",
  "Model S P85D",
  "X5 M",
  "560-4",
  "AMG S63",
  "M3 Coupe",
  "Quatroporte",
  "e-tron",
  "Ghibli Q4",
  "458 Spyder",
  "SL 500",
  "DB9 Volante",
  "Ranger Rover Sport",
  "Quattroporte SQ4",
  "488GTB",
  "612 Scaglietti",
  "911 Carrerra S",
  "Gran Turismo S",
  "Gran Turismo Convertible",
  "GL 450",
  "Continental GT V8 S",
  "Continental Gtc",
  "Vantage N420",
  "Panamera",
  "X5",
  "57S",
  "Arnage T",
  "Range Rover HSE LUX",
  "Cayman 718",
  "Phantom Drophead",
  "Vantage V8",
  "AMG GTC",
  "GT",
  "Granturismo Sport",
  "r8",
  "G550",
  "GV80",
  "GT R",
  "AMG GT S",
  "AR240 Jet Boat",
  "Carrera 4S Convertible",
  "C-Class",
  "SL 500 Designo",
  "NC895",
  "I8",
  "G-TR",
  "765 LT",
  "2500 Hybrid",
  "Supercharged",
  "R22 E",
  "GLE 300",
  "Z3",
  "GT V8",
  "Carerra 4",
  "S7",
  "Sprinter",
  "Spider 4C",
  "24C",
  "2dr Cabriolet 911 Carrera 4S",
  "G55",
  "gt4",
  987,
  "720s",
  "GLA",
  "X-45",
  "m",
  "GL-Class",
  "Targa GTS",
  "Pickup",
  "G Wagon 550",
  "210 FSH Deluxe",
  "Wakesetter",
  "GLS 450",
  "Range Rover SV Autobiography",
  "TS-450",
  "Lavente S",
  "Turbo Coupe",
  "G- Wagon",
  "Class 8",
  "GTS",
  "GT",
  "F-Pace",
  "Evoque Coonvertible",
  "MP 12C",
  765,
 
  "Aventador SVJ",
  "Gt",
  "glc300",
  "Panamera 4 AWD",
  "2200 Pure Bay",
  "Panamera 4",
  257,
  "SPX",
  "Quattroponte",
  "gt3rs",
  "G63",
  "X-45 Slider",
  "257SSX",
  "911 4 GTS TARGA",
  "P85",
  "Drophead",
  "G Wagon",
  "hse",
  "LR 4",
  "Benz FL500",
  "550 S",
  "Pontoon SLX",
  296,
  996,
  "Mayback",
  "911 Carrera 4 cabriolet",
  "SL55",
  "GT 4",
  "Discovery Sport HSE 4WD",
  "Aventador SV Roadster",
  "4C Spyder",
  "A8",
  "9114S",
  "Discovery",
  "Diablo Roadster",
  "R8 V8",
  "Mustang Shelby GT 500",
  "S75",
  "Hurracan EVO",
  "ML350",
  "Sport Super Charge",
  "570S",
  "Dawn Convertible",
  "E55",
  "458 Speciale Spider",
  "Carrera 911 S",
  "GV 80",
  "F355",
  "911 turbo",
  "Stelvio Ti Sport",
  "gt4",
  "Corvette Z06",
  "Ghibli",
  "NXT24",
  "Quattroporte Bace",
  "Db7 Vantage",
  "phantom",
  "DBX",
  "V-8 Vantage Coupe",
  "C300",
  570,
  "G-Class 550",
  "V8 Vantage GT Coupe",
  "Range Rover HS2",
  "966 CS4",
  "Z521C",
  "911 GTS Cabriolet",
  "GLS 63",
  "SL450",
  "996 Tiptronic",
  "E350",
  "R-8 Spyder",
  "Lr4 hse",
  "G 63 AMG",
  "glc 300",
  "911 4 Carrera Cabriolet",
  "GLA250",
  "R8",
  "Panamera",
  "360 Spider F1",
  "SILVER SPUR",
  "Range Rover Hse",
  "R8 V10 Plus",
  "SC",
  "C63",
  "Silver Wraith II",
  "997 turbo",
  "Range Rover Supercharged LWB",
  "GLC 300",
  "Q8",
  "Continental GTC Speed AWD",
  "GT-205",
  "Discovery 4.6L HSE7 V8 EFI",
  "Range Rover Sport 5.0L HSE",
  "ML63 AMG",
  "Expedition",
  "Q5",
  "911 carrera cabriolet",
  "S6",
  "boxer s",
  "Caymans",
  "boxter",
  "S 550",
  "SLK AMG",
  750,
  "R500",
  "Z3",
  "C250",
  "GLE 63S Coupe",
  "GIULIA QUADRIFOGLIO",
  "Mustang Saleen S281",
  "Super Snake",
  "Grand Turismo MC convertible",
  "Range Rover supercharged",
  "Z4",
  "Boxter Base",
  "Europa",
  "LS",
  "225 LR",
  "Boxster PDK",
  "911 Carera S",
  "911 S Convertible",
  "SL550",
  "Turbo S",
  "CL500",
  "911 Carrera Cabriolet",
  "CLS-Class",
  "Huracan Spyder",
  "CLS AMG",
  
  "G",
  "AMG E63 Wagon",
  "Spider",
  "350 E",
  "GLS",
  "2660cc",
  "Caymen R",
  "SLC",
  "3 Wheeler",
  "3 Series",
  "Vantage Convertible",
  "Vanquish S Volante",
  "SLS AMG",
  360,
  "Range Rover LWB",
  "Reith",
  "Challenger SRT Demon",
  "S600",
  "997 Carrera 2S",
  "911 40th Anniversary Edition",
  "GTC 4 Lusso Coupe",
  "SL 63 AMG",
  "911 GT2",
  "4-Seat",
  "Boxter",
  "GL350",
  "G65",
  "XJL",
  "599 GTB Fiorano",
  243,
  "Cls550",
  "2855 CIERA",
  "GLE AMG 43 Coupe",
  "650s",
  "911 turbo cabriolet",
  "S550",
  "Q60",
  "Cayenne Gts",
  "GLS Maybach",
  "Gallardo Superleggera",
  "239 FS",
  "CLA 45 Amg",
  "Boat",
  "v8 vantage",
  "212LS Riata",
  "AMG GTS",
  "244 Bay",
  "Hurricane Spider",
  "Uris",
  "Quattroporte Executive GT",
  "255 Deep V",
  "GLK250",
  "Sun",
  "212S",
  "FL400",
  "GLA45 AMG",
  "Benz",
  "E450 Wagon",
  "911 Carrera 4S Cabriolet AWD",
  "23EQWWA",
  "CONTINENTAL GT",
  
  "Panamara GTS",
  "GranTurismo Convertible Sport",
  "Boxter RS60 Spyder",
  "S63 AMG",
  "G500",
  "Aggressor",
  "C 300",
  "Gt",
  "Stelvio Quadrifoglio",
  "GLK-Class",
  "Italia 458",
  "Convertible",
  "Wraight",
  "Continental Speed",
  "535XIT",
  "AC Cobra replica",
  "3 Series 340i",
  "F40",
  "GLC 43 AMG",
  "G55 AMG",
  "GLC43 AMG",
  "Panamara",
  "Shelby Gt 500kr",
  5,
  "Gran Turismo Sport",
  "488 Convertible",
  "S550 4 Matic",
  "V12",
  "Lr4 HSE",
  "Cambria Corsa",
  "CL63",
  "Cls63 AMG",
  "Montero",
  "E 400",
  "Gran Tursimo",
  "Cayenne gts",
  "Phanton",
  "430 Scuderia",
  "Cambiocorsa",
  "Ghibli",
  "911 Carrera Cabriolet 4S",
  "Quattroporte S Q4 AWD",
  "Q50",
  "E400 Cabriolet",
  "C8",
  "Kelargo",
  "ML-Class",
  "G-Class AMG",
  "F12 Special Series",
  "Veyron",
  "718 Cayman S",
  "Model S P85",
  "Wakesetter 23LSV",
  "302CC",
  "B52",
  "430 Scuderia Spider",
  "212X",
  "G-63",
  "Gl550",
  "AMG G63",
  "911 S Carrerra",
  "S450",
  "s",
  "DB Mark III",
  "Panamera4",
  "Carrera Cabriolet Turbo",
  "Superamerica",
  "911 Carrara",
  
  "Continental Gt Speed",
  "S226",
  "Sport HSE LUX",
  "Charger Hell Cat",
  "Sprinter",
  "cls 55 amg",
  "Mp12-4c",
  "Model y",
  "Model x p90d",
  "GranTurismo sport",
  "911 carrera s",
  "S-550",
  "Carrera",
  "V12 Vantage S Roadster",
  "911 GT2 RS",
  "sprinter 2500",
  "S Long Range",
  "BOXTER",
  "S63",
  "911 Carrera 2 S",
  "S63",
  "SLR McLaren",
  "458 Italia Spyder",
  "E 350",
  "Boxter 718s",
  "Ghost",
  "340I",
  "Model s 90d",
  "911 Turbo Carrera",
  "Range Rover Sport",
  "Panamera S Hybrid",
  "Cayenne 4.8L V8 Twin Turbocharger AWD",
  "LR4 HSE Luxury",
  "C250",
  "HSE P38",
  "Panamera S-Hybrid",
  "Evora S",
  "Giulia T1 AWD",
  "SLK55 AMG",
  "adventador",
  "STS",
  "V12 Vanquish Volante",
  "Boxster",
  "MP4",
  "Gran Turismo",
  "Cobra/Resto Mod built 2005",
  "GranTurismo s",
  "M6 Convertible",
  "GT2RS",
  "US-PI0JT034G506",
  "V8",
  "SL 63 AMG",
  "599 GTB",
  "Embassador",
  "911 Turbo Cabriolet Convertible",
  "718 S",
  "Mecan",
  "340i",
  "AMG GTR",
  "F-350",
  "Cayman s",
  "Challenger 180 SE",
  "Cargo Van",
  "Coupe Cambiacorsa",
  "sport",
  "540C",
  "Bentaga",
  "quattroporte",
  "Mustang Heritage H302",
  "LR4",
  "Ghibili sq4",
  "Ghibli S.q4",
  "Caynne",
  "Charge",
  "911 s coupe",
  356,
  "Air",
  "CLA35AMG",
  "s550",
  "GTS",
  "SL 55 AMG",
  "Model S 75",
  "Carrera 4s",
  "Sport Supercharged",
  "Stelvio AWD Quadrifoglio",
  "LP-560",
  "viper",
  "911 c4 Convertible",
  "GT3",
  "GLA 45",
  "GLK-Class 350",
  "Sprinter 3500",
  "718 Boxter",
  "Cayman S",
  "G550",
  "911 Turbo S",
  "Model s",
  "Evouque",
  580,
  "Cayenne E-Hybrid",
  "cayenne S E hybrid",
  "Prowler",
  "550 Maranello",
  "E 350",
  "CLA 45 AMG",
  "911. Carrera 4S Cabriolet",
  "356 Speedster",
  "F150 XLT",
  "GTC Speed",
  "Maybach",
  "911 TT S",
  "Spider F430",
  "Silver Seraph",
  "SLK300",
  "azure",
  "E55",
  "GT",
  "LR2 SE",
  "GLK 350",
  "Evoke",
  "CLK",
  "SL-550",
  "ALPINA B7",
  "Sundance 24 Ft",
  "SL55 AMG",
  "Discovery Series II",
  2015,
  "Cobra- Replica Kit Car",
  "252 Coastal",
  "242xe",
  "AMG 63 SL",
  "AMG GTS",
  "Extended Wheelbase",
  
  "XJ",
  "911 Carrara S",
  "Xstar",
  "RS7",
  "GT Convertible",
  "Sprinter Van",
  "S90D",
  "SL500 AMG",
  "SL55 AMG",
  "Coupe Gt",
  "turbo cayanne",
  "Wake Setter LSV",
  "XE",
  "CL550",
  "E400 Wagon",
  "M6 Series",
  888,
  "S550",
  "CL63 AMG",
  "Countach",
  "ML63 AMG",
  "E400 RWD",
  "S100D",
  "Max",
  "S Class Coupe",
  "ZX22",
  
  "GL 63 AMG",
  "CA",
  "Aventador Roadster",
  "evoque",
  "Discovery S",
  "S4",
  "Cobra",
  "300C",
  "C43",
  "XF Sedan",
  911,
  "Gtr",
  "E-Class",
  "Levante S",
  "WT-2DC",
  "Super Sport GTC",
  "GTM",
  "New York",
  "CLS400",
  "Skiff on trailer 175 HP Evenrude",
  "Macon S",
  "Series 6",
  "Macan",
  "SLC300 AMG 43",
  "ML320 CDI",
  "AMG 63 Convertible",
  "panamera",
  "CLS-Class",
  "E55 AMG",
  "S500",
  "GTC",
  "Gt-r",
  "SE",
  "MP4 12C",
  "Cl 550",
  "C250 coupe",
  "Callardo",
  "Lavente",
  "Sport",
  "model X",
  "Super Aire 230",
  "M4",
  "G-Class G63",
  "M4 Competition Convertible",
  "Saleen Yellow Label",
  "G21",
  "Huracan Evo",
  261,
  "Stelvio Ti",
  "Range Rover SC SUV",
  "Pro 19",
  "255 FSH",
  "cls550",
  "GL450",
  "255 DC",
  "S3",
  "GLS 450",
  "SW20B",
  "190 Sport",
  "levante s grand lusso",
  "cayenne s",
  "237CC",
  "R8",
  "Panamera Turbo S Executive",
  "310 Signature",
  "E-Class E63 AMG",
  "NXT20",
  "AMG GT R Renntech",
  240,
  "G55amg",
  "CRV",
  "E Class",
  "Cobra (Replica)",
  "Center Council",
  "26 Hybrid",
  "SL450",
  "V215SX",
  "Range Rover Autobiography",
  "Giulia",
  "242XE",
  "Evoq",
  "230 Bay Reef",
  "cl",
  "DB11",
  "252 FSH",
  "Rs 7",
  "GT 63S",
  "Panamera GTS",
  "S-Class",
  "model s",
  "granturismo",
  "CLS-Class AMG 63",
  "G Wagon",
  "CL65",
  "Cayenne Turbo - S",
  "LX600",
  "GLE",
  "9911 Carrera Cabriolet Black Edition",
  "Evoque HSE Dynamic",
  "765LT",
  "Quattro Vortex",
  "CLK-Class",
  "Carrera 2",
  "Continental GT Diamond Series",
  "ML 63AMG",
  "Aero Supersport",
  "911 Carerra",
  "HSE sport",
  "GL50",
  "c 300",
  "Range Rover Evoke",
  "Cayenne AWD",
  "ML63",
  "azur",
  "ML 350",
  "911 carrera",
  "Granturismo MC Centennial Special Edition",
  "911 Carerra 4S",
  "Cayenne GPS",
  "Adventador",
  "GL450",
  "911 Targa",
  
  "Roma",
  "Z4",
  "DBX 707",
  "Granturismo",
  "GranTurismo",
  "SL 55 AMG",
  "911 cabriolet",
  "Spider",
  "Roadster (KIT CAR)",
  "Giraffe",
  "Phaetom",
  "G-Wagon",
  "Phantom",
  "GTH",
  "F Type Convertible",
  "Carrera 911 Cabriolet",
  "E550 4matic",
  "DB9 Volante V12",
  "HSE Supercharged",
  "Cayenne",
  "S65 AMG",
  "Cayman F",
  "M Class",
  "a8 L",
  "GTS Coupe",
  "Amg GT S",
  "Ghose",
  "Z4 M",
  "Lavantae",
  "E350",
  "2500 Sprinter Van",
  "Sprinter Van",
  "E 400",
  "Giulia Quadrifoglio",
  "GIULIA TI Q4",
  "Cayenne S Turbo",
  "Race",
  "600lt",
  "GT3 RS",
  "911 carrera 4s",
  "AMG GTS",
  "GLE 350",
  "Slk 350",
  "CALIFORNIA T",
  "ML 400 4MA",
  "Cayman",
  "CL500",
  "A8l",
  "Phantom VI",
  "Gtc",
  "S550 Coupe",
  "P1",
  "Exige S",
  "911 Turbo S cab",
  "Range Rover Autobiography SV",
  "812 SUPER FAST",
  "GT Sport",
  "C63",
  "cayman s",
  "GLE350",
  "E63",
  "Boxster SE 550",
  "macan S",
  "4c spider",
  "GL63",
  "85D",
  "Exige s",
  "SUV",
  "C 63 AMG",
  "m6",
  "Huracan LP610-4",
  "911 Carrera GTS",
  277,
  "S600",
  "S450",
  "Model 3",
  "CLC 63 S",
  "Boxster",
  "Mle",
  "H2 Limo",
  "S650 X",
  "Macan Turbo w/ Performance Pkg",
  "238SS",
  "GTM",
  "S P100 D",
  "Model",
  "e300",
  "458 Italia Spider",
  "Sunesta 232",
  "Mustang Saleen",
  "Cayman s",
  "Cayman S 981",
  "R8 V10",
  "SKR",
  "Ghibli s Q4",
  "Odyssey",
  "911 carrera 4S",
  "Ghibli S",
  "SC430 Convertible",
  "ML350",
  "C230 Kompressor",
  "s55 AMG",
  "580 S-Class",
  "911 C4 Cabriolet",
  "hse",
  "GT3",
  "CAYENNE S",
  "panamera 4S",
  "Type 57",
  "cayman r",
  "LR2 HSE",
  "SL 550",
  "boxster s",
  "Italia",
  "E43 AMG",
  "Nitro",
  "continental gt",
  "Metris",
  "Range Rover SC Autobiography",
  "Alpina b7",
  "570GT",
  "A20",
  "242 limited",
  "Cuda",
  "911 Coupe",
  "550SL",
  "911 C4",
  "911 4C",
  "E 63 AMG",
  "Guilia Quadrifoglio",
  "Continental GT Convertible V8",
  "Range Rover Sport LUX",
  "Aventador LP700-4",
  "Model X 100D",
  "SLK250",
  "S - P85D",
  "GR3RS",
  "CLK 320",
  "Fire",
  "360 spider",
  "S350",
  "Express cruiser",
  "cls-63",
  "Prowler",
  "Gls 550",
  "Yacht Cruiser 30 ft.",
  "C250 Sport",
  "S-Type",
  "Discovery II SE7",
  "Diablo VT Roadster",
  "S550 4Matic",
  "Range Rover 4d Wagon SC",
  "Cayenne turbo",
  "Quattroporte Sedan",
  "911 Turbo",
  "Cobra Rep",
  "911 Carrera",
  "GT 3 RS",
  "Sprinter 2500",
  "Discovery SE7",
  "SL 65",
  "Panamera S E-Hybrid",
  "266 Commander",
  "Silver Spur",
  "Vantage Volante",
  "Turbo Cabriolet",
  "Boxster",
  "P85 Plus",
  "Ranger rover",
  "GLE 63 AMG",
  "Alpina B6",
  "BOXTER SPYDER",
  "AMG GT",
  "BOXSTER S",
  "911 CARERRA",
  "4200 CC",
  "Hell Cat",
  
  "TT RS",
  "Esperante",
  "Cayenne S Titanium",
  "Discovery Sd",
  "Carrera Gt",
  328,
  "Gt Coupe",
  "Gransport Spyder",
  "",
  "Discovery (series 2)",
  "rang rove sport hse",
  "f430",
  "Berlinetta",
  "Range Rover Sport HSC",
  "Continental GT",
  "Ghilbi",
  "Continental GT",
  "Panamera GTS",
  "250 Carolina Flair",
  "Granturismo S",
  430,
  "CLS 53",
  "Continental gt",
  "model s",
  "911 Carrera 4 S",
  "boxster",
  "4c",
  "Db7",
  "Corvette",
  944,
  "298ss",
  "911 Coupe Carrera 997",
  "E63S AMG",
  "CLK 350 CABRIOLET",
  "taycan",
  "Continental V8S",
  "Range Rover Sport SC",
  911,
  "750li xdrive M sport",
  "M4 Convertible",
  "SLK AMG",
  "Ranger Rover Velars",
  "Carrera S 911",
  "Continenetal GT",
  "Gallardo Spider",
  "911 C4S Cabriolet",
  "911 Carera Cabriolet",
  "911 Carrera 4S",
  "Karma Eco-Sport",
  "Z4 3.0 I",
  "CARRERA 4S",
  "Caymen S",
  "GTC",
  "S331",
  "356 replica",
  "XB7",
  "Turbo S Cabriolet",
  "Cayman",
  "Range Rover Sport",
  "P85d",
  "G 63",
  "GLS-Class",
  "nsx",
  "Seahawk OS 2700",
  "Levente",
  "Grandsport",
  57,
  "911 S convertible",
  "GrandTurismo",
  "SL65",
  "F430",
  "Phantom Coupe",
  "Cobra Replica",
  "F Type",
  "GT Coupe",
  "911 gt3",
  "Cayman",
  "SLK55",
  "X6 M",
  "ML550 4Matic",
  "Sport HSE, v8 not supercharged",
  "E Class 63 Wagon AMG",
  "RS4",
  "Continental Silver Spur",
  "75D",
  "Viper TA2.0 Nth Moto Viper",
  "Continental GTC Speed",
  "Autobiography Super Charged",
  "panamera",
  "911 Carerra 4",
  "911 TARGA 4S",
  "CT5 Blackwing",
  "GL550",
  "S",
  "A220",
  "350CLK",
  "Cayenne",
  "MC Centennial",
  "F",
  "C43",
  "Hura",
  "C class c 300 sport",
  "Bentayga V8",
  "Macan F",
  "Whaler 37 Outrage",
  "Vanquish S",
  "Range Rover Super Charged",
  "Range Rover SC",
  "S400",
  "ML550",
  "C55",
  "911 Carrera 4s",
  "4c",
  "911S4",
  "12C-MP4",
  "flsamg",
  "DV80",
  "C250",
  "CLS500",
  "Boxster Spyder",
  "Boat",
  "G55 AMG",
  "GT R",
  "SL 500",
  "550 CLS 63 AMG",
  "GLK",
  "911 Carrera cabriolet",
  "E63 AMG S",
  "GLC-63s AMG",
  "Range Rover Sport SE",
  "GLE 350",
  "GTR AMG",
  "Slk 55",
  "Roadster- Replica",
  "sl500",
  "GT C",
  "Giulia",
  "S55 AMG",
  "240 Sundancer",
  "G-Wagon",
  "Skiff",
  "SL63",
  "Sport HSE",
  "SLS",
  "CAYMAN S",
  "SL-63 AMG",
  "SL",
  "911 Targa 4 GTS",
  "FSH 210",
  "M6",
  "PORTOFINO",
  "V8 Vantage GT",
  "Roadster",
  "911 Turbo 4 Coupe",
  "GT2rs",
  "SRT",
  "CLK55 AMG",
  "DB 9",
  "488 GTB",
  "Huracan 580-2 spider white color",
  "R3 Surf Bowrider",
  "E450 Convertible",
  "E350 Class",
  "G55",
  "Range Rover Super Charge",
  "AMG C63s",
  "Maybach 6",
  "GHOST",
  "M5",
  "Continental GTC V8",
  "Continental Flying Spur Speed",
  "Saleen",
  "E 320 Sedan",
  "911 c4s convertible",
  "Gran Tourismo Sport",
  "456 M",

  "gt sport conv",
  "m3",
  "m4",
  "Arnage RL",
  "DB 9",
  "S 550E",
  "230 i",
  "AMG G55 G-Wagen",
  "Cobra Kit Car",
  "Model S 85D",
  "levante",
  "GTC S",
  "S63",
  "V8 Vantage S",
  "C63 AMG",
  "rapide",
  "CLA 250",
  "Gls 550",
  "CLS400",
  "Cayanne",
  "C 63",
  3500,
  "M 235",
  "Chiron",
  "Q7",
  "911 Carrera 4S Targa",
  "urus",
  "boxster",
  "range rover gt limited",
  "Xk",
  "Aventador LP700-4.",
  "335i Coupe",
  "911Turbo S",
  "911 Targa 4",
  "Range Rover Sport",
  "CLS",
  "Model S 85 D",
  "Range Rover Super Sport",
  "s8",
  "Model S",
  "S 430",
  "E 43 AMG",
  "Gl450",
  "911 GT3 Touring",
  "Quartroporte",
  "C63s AMG Sedan",
  "Sl500",
  "Yacht",
  "Cayenne Triptonic",
  "LR4",
  "Mulsanne",
  "grantourismo",
  "GLA 45 AMG",
  "M-class SUV350",
  "LR HSE",
  "Turbo S cabriolet",
  "GLS550",
  "GLS 550",
  "Huracan 2WD",
  "S plaid",
  
  "Panamera E Hybrib",
  "R8",
  "M12 GTO",
  "911 Cabriolet",
  "Carrera C4",
  "911 Carrera GT S",
  "Panamera turbo s",
  "Factory 5 Kit Car",
  "Range Rover Sport Autobiography",
  "Mustang Extreme",
  "ML350",
  "E 350 sport",
  "Quattroporte GT",
  57,
  "911 Turbo Coupe",
  "huracan",

  "Hse Lux Silver",
  "V8 Vantage",
  "599 Gtb Fiorano",
  360,
  "AMG 63",
  "911 Carrera 4 Cabriolet",
  "308 Convertible",
  "Panamera S",
  "Gv70",
  "X Star",
  "Continenetal"
]

export const standard_sports = [
  "LAND ROVER SPORT",
  "Land Rover Super Charge",
  "Range Rover Sport supercharged",
  "Range Rover sport",
  "Camaro ss", 
  "Range Rover",
  "Range Rover Evoque",

]
